import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AOS from 'aos';
// import '/assets/css/aos.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './pages/About';
import Business from './pages/Business';
import Service from './pages/Service';
import Solutions from './pages/Solutions';
import Support from './pages/Support';
import Notice from './pages/Notice';
import NoticeView from './pages/NoticeView';
import Contract from './pages/Contract';

const App = () => {
 
  AOS.init();      
 
  return (
    <>
      <Header />
      
      <Routes>
          <Route path="/*" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/business" element={<Business />} />
          <Route path="/service" element={<Service />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/support" element={<Support />} />
          <Route path="/notice" element={<Notice />} />
          <Route path="/noticeview" element={<NoticeView />} />
          <Route path="/contract" element={<Contract />} />
          {/* 다른 페이지 라우트 추가 */}
      </Routes>
     
      <Footer />
    </>
  );
};

export default App;